import { render } from "./InstantMeetingButtonView.vue?vue&type=template&id=595cb1f0"
import script from "./InstantMeetingButtonView.vue?vue&type=script&lang=js"
export * from "./InstantMeetingButtonView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__